import { FC } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import clsx from 'clsx';

import { DownloadBtn } from '@/components/UI';

import { TAccordionType } from '@/types/general/unions';

import styles from './MainAccordion.module.scss';

type AccordionFile = {
  href: string;
  title?: string;
};

interface MainAccordionProps {
  data: {
    title: string;
    content: string | JSX.Element | AccordionFile[];
    type: TAccordionType;
  }[];
  isQuestionsPage?: boolean;
  isHousesListPage?: boolean;
}

const MainAccordion: FC<MainAccordionProps> = ({ data, isQuestionsPage, isHousesListPage }) => {
  const buttonStyles = clsx(styles.button, {
    [styles.questionPage]: isQuestionsPage,
    [styles.housesListPage]: isHousesListPage,
  });
  const contentStyles = clsx(styles.content, {
    [styles.questionPage]: isQuestionsPage,
  });
  return (
    <Accordion allowZeroExpanded={true} allowMultipleExpanded={true}>
      {data.map((item, index) => {
        return (
          <AccordionItem className={styles.item} key={index}>
            <AccordionItemHeading>
              <AccordionItemButton className={buttonStyles}>{item.title}</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={contentStyles}>
              {item.type === 'image' && typeof item.content === 'string' ? (
                <img src={`${item.content}`} alt='' />
              ) : item.type === 'file' ? (
                Array.isArray(item.content) ? (
                  <div className={styles.files}>
                    {item.content.map((file) => (
                      <DownloadBtn key={file.href} href={file.href} title={file.title} />
                    ))}
                  </div>
                ) : (
                  typeof item.content === 'string' && <DownloadBtn href={item.content} />
                )
              ) : (
                <p className={'color-dark'}>{!Array.isArray(item.content) ? item.content : ''}</p>
              )}
            </AccordionItemPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default MainAccordion;
